import React from 'react';
import styled from 'styled-components/macro';
import Icon from '../Input/Icon';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

interface StatusIconProps {
  isSuccess: boolean;
  className?: string;
}

const StatusIcon: React.FC<StatusIconProps> = ({ isSuccess, className = '' }) => {
  return (
    <Wrapper className={className}>
      <div>
        {isSuccess ? (
          <Icon icon="check-filled" size="xs" style={{ color: '#4CAF50' }} />
        ) : (
          <Icon icon="times" size="xs" style={{ color: '#888888' }} />
        )}
      </div>
    </Wrapper>
  );
};

export default StatusIcon;
